// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import ImageOptionsComponent from 'components/engraving/ImageOptions/ImageOptions';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import { updateEngraving } from 'stores/actions';

class ImageOptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            prevStepPath: ''
        };

        this.setSteps(props.engraving.productId);
        this.formComponent = React.createRef();
    }

    componentDidMount() {
    }

    async onSubmit() {
        if (!this.formComponent || !this.formComponent.current) {
            return null;
        }
        const formData = await this.formComponent.current.handleSubmit();
        if (formData) {
            this.props.updateEngraving(formData);
            this.navigateTo('/engraving/final-approval');
        }
    }

    /**
     * Sets the navigation previous step. Only when the customise text option is available it will set the value to
     * navigate to engraving options, otherwise it'll be empty
     */
    setSteps(productId) {
        if (!productId) {
            return;
        }

        fetch('../fpc_config.json')
            .then((r) => r.json())
            .then((data) => {
                const selectedConfig = data.Config_File.find((x) => x.SugarID === productId);
                if (!selectedConfig) {
                    return;
                }
                if (selectedConfig.Dimensions !== '0') {
                    this.setState({
                        prevStepPath: 'engraving-options'
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    navigateTo(path) {
        this.props.history.push({
            pathname: path,
            search: this.props.location.search
        });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarPrimary hideNav />
                <div className="body-content engraving">
                    <PageTitle title="Engraving approval" />

                    <ContentCard
                        className="mt-62"
                        headerTitle="Customise Text"
                        divider={false}
                    >
                        <Container fluid className="engraving-container customise-text-container">
                            <ImageOptionsComponent
                                wrappedComponentRef={this.formComponent}
                            />
                        </Container>
                    </ContentCard>
                </div>

                {this.state.prevStepPath ? (
                    <FooterBtnActions
                        prevBtnOnCLick={() => this.navigateTo(`/engraving/${this.state.prevStepPath}`)}
                        nextBtnOnCLick={() => this.onSubmit()}
                    />
                ) : (
                    <FooterBtnActions nextBtnOnCLick={() => this.onSubmit()} />
                )}

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    engraving: state.engraving
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImageOptions));
